module.exports = __webpack_public_path__ + "static/media/NVA_Logo_SmallUse_RGB.c473cfa7.png";